(() => {
  const initAnchor = (root = document) => {
    const anchor = root.querySelector?.('.cv-tech-anchor') || document.querySelector('.cv-tech-anchor');
    if (!anchor || anchor.dataset.ready === 'true') return;
    anchor.dataset.ready = 'true';
    const links = [...anchor.querySelectorAll('a[href^="#"]')];
    const targets = links.map((link) => document.querySelector(link.getAttribute('href')));
    const pageEnd = document.querySelector('.cv-tech-closing');
    const placeholder = document.createElement('div');
    placeholder.className = 'cv-tech-anchor-placeholder';
    anchor.before(placeholder);
    let originTop = anchor.getBoundingClientRect().top + window.scrollY;
    let fixed = false;

    const visibleHeaderBottom = () => {
      let bottom = 0;
      document.querySelectorAll('.header-section .header').forEach((header) => {
        const rect = header.getBoundingClientRect();
        if (rect.bottom > 0 && rect.top < window.innerHeight) bottom = Math.max(bottom, Math.min(rect.bottom, 180));
      });
      return Math.max(0, Math.round(bottom));
    };

    const refresh = () => {
      const headerBottom = visibleHeaderBottom();
      document.documentElement.style.setProperty('--cv-tech-sticky-top', `${headerBottom}px`);
      if (!fixed) originTop = anchor.getBoundingClientRect().top + window.scrollY;
      const beforePageEnd = !pageEnd || pageEnd.getBoundingClientRect().bottom > headerBottom + anchor.offsetHeight;
      const shouldFix = window.scrollY + headerBottom >= originTop && beforePageEnd;
      fixed = shouldFix;
      anchor.classList.toggle('is-fixed', shouldFix);
      placeholder.style.height = shouldFix ? `${anchor.offsetHeight}px` : '0px';
      const marker = window.scrollY + headerBottom + anchor.offsetHeight + 28;
      let active = 0;
      targets.forEach((target, index) => {
        if (!target) return;
        const targetTop = target.getBoundingClientRect().top + window.scrollY;
        if (targetTop <= marker) active = index;
      });
      links.forEach((link, index) => link.classList.toggle('is-active', index === active));
    };

    links.forEach((link) => link.addEventListener('click', (event) => {
      const target = document.querySelector(link.getAttribute('href'));
      if (!target) return;
      event.preventDefault();
      const headerBottom = visibleHeaderBottom();
      const top = target.getBoundingClientRect().top + window.scrollY - headerBottom - anchor.offsetHeight - 12;
      window.history.replaceState(null, '', link.getAttribute('href'));
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      window.setTimeout(() => {
        const correctedHeader = visibleHeaderBottom();
        const correctedTop = target.getBoundingClientRect().top + window.scrollY - correctedHeader - anchor.offsetHeight - 12;
        if (Math.abs(window.scrollY - correctedTop) > 3) window.scrollTo({ top: Math.max(0, correctedTop), behavior: 'smooth' });
      }, 520);
    }));

    let ticking = false;
    const requestRefresh = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => { refresh(); ticking = false; });
    };
    window.addEventListener('scroll', requestRefresh, { passive: true });
    window.addEventListener('resize', requestRefresh);
    refresh();
  };

  const init = (root = document) => {
    initAnchor(root);
    root.querySelectorAll('[data-cv-tech-evidence]').forEach((section) => {
      if (section.dataset.ready === 'true') return;
      section.dataset.ready = 'true';
      const rail = section.querySelector('[data-cv-tech-evidence-rail]');
      const move = (direction) => rail?.scrollBy({ left: direction * Math.max(280, rail.clientWidth * .82), behavior: 'smooth' });
      section.querySelector('[data-cv-tech-prev]')?.addEventListener('click', () => move(-1));
      section.querySelector('[data-cv-tech-next]')?.addEventListener('click', () => move(1));
    });
  };
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
